const SDK_VERSION = '7.79.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
